import script from "./MapInputPoint.vue?vue&type=script&setup=true&lang=js"
export * from "./MapInputPoint.vue?vue&type=script&setup=true&lang=js"

export default script